import styles from "./styles";
import palette from "../../../styles/palette";
import { type PropsWithChildren } from "react";

interface NotchedCardProps {
    label: string,
    style?: React.CSSProperties,
    center?: boolean,
    labelStyle?: React.CSSProperties,
    borderColor?: string | null,
    backgroundColor?: string | null,
    containerProps?: JSX.IntrinsicElements['div'] & { 'data-testid': string }
}

const NotchedCard = (props: PropsWithChildren<NotchedCardProps>) => {
    const labelStyle = props.labelStyle == null ? styles.cardLabel : { ...styles.cardLabel, ...props.labelStyle };

    const cardPadding = {
        ...styles.cardPadding,
        border: `solid 2px ${props.borderColor ?? palette.border.primary}`,
        background: props.backgroundColor ?? "inherit"
    }

    return (
        <div style={props.style == null ? styles.card : { ...styles.card, ...props.style }} {...props.containerProps}>
            <div style={styles.cardInner}>
                <div style={props.center == true ? { ...cardPadding, ...styles.alignCenter } : cardPadding}>
                    <div style={labelStyle}>{props.label}</div>
                    <div style={{ width: "100%" }}>{props.children}</div>
                </div>
            </div>
        </div>
    )
}

export default NotchedCard;